import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../slices/userSlice";
import { parseJwt } from "../utils/JwtDecode";
import logo from "../Static Files/Images/HomePage/Logo Transparent.png";
import "../Static Files/styles/sidebar/sidebar.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginUser(formData));

    if (result.payload && result.payload.token) {
      const decodedToken = parseJwt(result.payload.token);
      localStorage.setItem("token",result.payload.token);
      if (parseJwt(localStorage.getItem("token"))?.role === "Admin") {
        navigate("/admin");
      } else {
        navigate("/unauthorized");
      }
    } else {
      navigate("/unauthorized");
    }
  };

  return (
    <>
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:"flex",alignItems:"center",gap:"1vw"}}>
          <img
            style={{ width: "7vw", height: "7vw" }}
            src={logo}
            alt="logo"
          />
          <h2 style={{fontWeight:"700",fontSize:"3vw"}}>Joyful<span style={{color:"#ff6010"}}>  Admin</span></h2>
        </div>
        <h2 style={{marginTop:"4vw"}}>Giriş edin!</h2>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Şifrə"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit" className="submit-btn">
          Daxil ol
        </button>
      </form>
    </>
  );
};

export default Login;
